/**
 * Handles radios and checkboxes change event to toggle a class to a given element
 * @module toggleChange
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
export const PLUGIN_NAME = 'toggleChange';
export const DEFAULTS = {
  ctToggleClass: '',
  ctSelector: '',
  ctInverse: false,
};


/**
 * Return the input type of the element
 * @param  {jQuery} $el - checkbox / radio
 * @return {String} type of either checkbox or radio
 */
const inputType = $el => $el.attr('type');

/**
 * Return radio group
 * @param  {jQuery} $el - checkbox / radio
 * @return {jQuery} radio group
 */
const radioGroup = ($el) => {
  const groupName = $el.attr('name');
  return $(`input[type="radio"][name="${groupName}"]`);
};

const toggleClassHandler = ($el, action, opts) => {
  if( action == "add" && !opts.ctInverse || action == "remove" && opts.ctInverse ) {
    $el.addClass(opts.ctToggleClass);
  }
  if( action == "remove" && !opts.ctInverse || action == "add" && opts.ctInverse ) {
    $el.removeClass(opts.ctToggleClass);
  }
}

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, options = {}) => {
  const $selector = $(options.ctSelector);
  const type = inputType($el);
  if (type === 'radio') {
    const $radioGroup = radioGroup($el);
    const deselectEvent = `deselect-${$el.attr('name')}`;
    $radioGroup.on('click', function customDeselectEvent() {
      if ($(this)[0].closest('.is-selected') !== null) {
        return;
      }
      $(`input[name="${$(this).attr('name')}"]`).not($(this)).trigger(deselectEvent);
    });
    $el
      .on('change', () => {
      toggleClassHandler($selector, "add", options);
    })
    .on(deselectEvent, () => {
      toggleClassHandler($selector, "remove", options);
    });
  }
  if (type === 'checkbox') {
    $el.on('change', (evt) => {
      if (evt.currentTarget.checked) {
        toggleClassHandler($selector, "add", options);
      }
      if (!evt.currentTarget.checked) {
        toggleClassHandler($selector, "remove", options);
      }
    });
  }
};
/**
 * Set dom state if element is checked
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setChecked = ($el, options = {}) => {
  const $selector = $(options.ctSelector);
  if ($el[0].checked && !options.ctInverse) {
    $selector.addClass(options.ctToggleClass);
  }
};
/**
 * Initializes toggleChange.
 * @param {HTMLElement} el - button /element that triggers toggleChange
 * @param {Object} options - Options used for wiring up the toggleChange
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function toggleChange(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
  setChecked($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, toggleChange);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-change.js